import I18n from 'i18n-js';
import { absAmount, formatPrice, isNegativeAmount } from './currency';

// eslint-disable-next-line import/prefer-default-export
export const getExpectationMessage = id => {
  const EXPECTATION_MESSAGE = {
    1: {
      title: I18n.t('expectationManagement.rain.title'),
      body: I18n.t('expectationManagement.rain.body'),
    },
    2: {
      title: I18n.t('expectationManagement.traffic.title'),
      body: I18n.t('expectationManagement.traffic.body'),
    },
  };

  return EXPECTATION_MESSAGE[id];
};

export const getFallbackCashExpectation = ({ total, symbol }) => {
  const payToDriver = !isNegativeAmount(total);
  const titleKey = payToDriver
    ? 'expectationManagement.payment.pay.title'
    : 'expectationManagement.payment.collect.title';

  return {
    title: I18n.t(titleKey, {
      price: formatPrice({
        amount: absAmount(total),
        symbol,
      }),
    }),
    body: payToDriver ? I18n.t('expectationManagement.payment.pay.body') : '',
  };
};

export const getCashExpectation = ({ total, symbol }) => {
  const payToDriver = !isNegativeAmount(total);
  const titleKey = payToDriver
    ? 'expectationManagement.payment.payCash.title'
    : 'expectationManagement.payment.collect.title';

  return {
    title: I18n.t(titleKey, {
      price: formatPrice({
        amount: absAmount(total),
        symbol,
      }),
    }),
    body: payToDriver
      ? I18n.t('expectationManagement.payment.payCash.body')
      : '',
  };
};

export const getCashlessExpectation = ({ total, symbol }) => ({
  title: I18n.t('expectationManagement.payment.payCashless.title', {
    price: formatPrice({
      amount: total,
      symbol,
    }),
  }),
  // body: I18n.t('expectationManagement.payment.payCashless.body'), // hide it for cashless POD phrase 1, ref: https://jira.grab.com/browse/DELVOD-16236
});

export const getNonBookerCashlessExpectation = ({ total, symbol }) => ({
  title: I18n.t('expectationManagement.payment.nonBookerCashless.title', {
    price: formatPrice({
      amount: total,
      symbol,
    }),
  }),
  body: I18n.t('expectationManagement.payment.nonBookerCashless.body'),
});

export default {};
